export enum GridActions {
  edit = 1,
  id = 2,
  comment = 3,
  remove = 4,
  information = 5,
  attachment = 6,
  link=7,
  application = 8,
  publish=9,
  unpublish=10,
  email=11,
  copy=12,
  download = 13,
  userPermission = 14,
  subjectAllocation=15

}
export enum GridOperations {
  printIdCard = 1,
  printReportCard = 2,
  alumni = 3,
  remove = 4,
  email = 5,
  sms = 6,
  block = 7,
  unblock = 8,
  subscribeEmail = 9

}
